import { render, staticRenderFns } from "./productQZdetail.vue?vue&type=template&id=35d4af24&scoped=true"
import script from "./productQZdetail.vue?vue&type=script&lang=js"
export * from "./productQZdetail.vue?vue&type=script&lang=js"
import style0 from "./productQZdetail.vue?vue&type=style&index=0&id=35d4af24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d4af24",
  null
  
)

export default component.exports